export default "__VITE_ASSET__3f3b7352__"